const meta = {
  practiceSlug: "",
}

type TrackingMetaKey = keyof typeof meta

/**
 *  A function to get a specific tracking meta property. This should be only
 *  used for by tracking code.
 */
export function getTrackingMeta(property: TrackingMetaKey) {
  return meta[property]
}

/**
 *  A function to set a specific tracking meta property.
 */
export function setTrackingMeta(property: TrackingMetaKey, value: string) {
  meta[property] = value
}

/**
 *  Reset all tracking meta properties to their defaults. Should be done when user
 *  logs out.
 */
export function resetTrackingMeta() {
  meta.practiceSlug = ""
}
